module.exports = __webpack_public_path__ + "img/category_31.09614b69.png";